import { Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { User } from '../model/user.model';
import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { Role } from '../model/role.model';
@Injectable()
export class AuthService {

  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  constructor(
    private router: Router,
    private httpClient: HttpClient,
    @Inject('BASE_URL') private baseUrl: string) {
      this.intiUser();
    }


  intiUser() {
    if (this.checkLocalStorage) {
      this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    } else {
      this.currentUserSubject = new BehaviorSubject<User>(null);
    }
    this.currentUser = this.currentUserSubject.asObservable();
  }


  get checkLocalStorage() {
    try {
        if (localStorage) {
          return true;
        }
        return false;
    } catch(e) {
        return false;
    }
  }


  login(username: string, password: string) {
    if (!this.checkLocalStorage) {
      return throwError('lblCookiesDisabled');
    }


    return this.httpClient.post<User>(`${this.baseUrl}/api/User/Authenticate`, { username, password })
        .pipe(map(user => {
            // login successful if there's a jwt token in the response
            if (user && user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(user));
                this.currentUserSubject.next(user);
            }
            return user;
        }));
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
  }

  updateUser(user: User){
    this.currentUserValue.name=user.name;
    this.currentUserValue.lastName=user.lastName;
    this.currentUserValue.phone=user.phone;
    this.currentUserValue.email=user.email;
    this.currentUserValue.username=user.username;
    localStorage.setItem('currentUser', JSON.stringify(this.currentUserValue));
  }

  get currentUserIsAdmin() {
    return this.currentUserValue && this.currentUserValue.role === Role.Admin;
  }

  get currentUserIsUser() {
    return this.currentUserValue && this.currentUserValue.role === Role.User;
  }

  get currentUserIsInstructor() {
    return this.currentUserValue && this.currentUserValue.role === Role.Instructor;
  }
}
